import { Pipe, PipeTransform } from '@angular/core';
import { QuestionType } from '../models/question.quiz.model';

@Pipe({
  name: 'questionTypeLabel',
  standalone: true,
})
export class QuestionTypePipe implements PipeTransform {
  questionTypesList = Object.entries(QuestionType).map(([key, value]) => ({
    key,
    value,
  }));

  transform(value: string): string {
    return (
      this.questionTypesList.find((qt) => qt.key === value)?.value || value
    );
  }
}
